const TotalIRRDisplay = ({ years, annualRate }) => {
    return (
        <span className="black-text">
            <b>{years}-year IRR:</b> {((Math.pow(1 + parseFloat(annualRate) / 100, parseInt(years)) - 1) * 100).toFixed(2)}%
        </span>
    );
};

export default TotalIRRDisplay;